import { ComponentPropsWithoutRef, FC, ReactNode } from 'react';
import { Checkbox, Radio } from 'react-daisyui';
import { cn } from '@/utils/classNames.ts';

export type CheckboxInputProps = ComponentPropsWithoutRef<typeof Checkbox> & {
  label?: ReactNode;
  error?: string;
  wrapperClassName?: string;
  type?: 'checkbox' | 'radio';
};

const CheckboxInput: FC<CheckboxInputProps> = ({ wrapperClassName, label, error, type = 'checkbox', ...args }) => {
  return (
    <div className={cn('flex flex-col gap-1', wrapperClassName)}>
      <label className="label cursor-pointer justify-start gap-2 p-0">
        {type === 'checkbox' ? <Checkbox {...args} /> : <Radio {...args} />}
        <span
          className={cn('label-text', {
            'text-error': !!error,
          })}
        >
          {label}
        </span>
      </label>
      {error && <span className="text-sm text-error">{error}</span>}
    </div>
  );
};

export default CheckboxInput;
